import './scss/avatar.scss'
import {AvatarComponent} from './AvatarComponent'

const AvatarPackage = {
    name: 'UIAvatar',
    configure: function(config) {
        config.addComponent('UIAvatar', AvatarComponent, false, 'avatar')
    }
}

export {AvatarPackage}
